export const Venue = () => {
  return (
    <>
      <div id="venue" className="lg:px-24 lg:my-20 px-4 mb-10 py-6 bg-[#33358c] text-[#fff] flex flex-col md:flex-row md:justify-evenly md:items-center">
        <div className="mb-6 lg:mb-0">
          <div className="mb-4">
            <p className="font-bold text-3xl text-center mb-4">Venue</p>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.637177628496!2d77.4913143!3d28.460351700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cc1e13dcbf0eb%3A0xfcf1c4d9749a78b4!2sIILM%20University%2C%20Greater%20Noida!5e0!3m2!1sen!2sin!4v1731074357699!5m2!1sen!2sin"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="flex items-center justify-center flex-col">
          <div className="mb-4">
            <p className="font-semibold text-2xl text-center mb-4">IILM University, Greater Noida</p>
            <p className="text-md text-center px-4">
              Plot No. 16-18, Knowledge Park II, Greater Noida, Uttar Pradesh-201306
            </p>
          </div>
          <div>
            <a
              href="https://www.google.com/maps/place/IILM+University,+Greater+Noida/@28.4603517,77.4887394,17z/data=!3m1!4b1!4m6!3m5!1s0x390cc1e13dcbf0eb:0xfcf1c4d9749a78b4!8m2!3d28.4603517!4d77.4913143!16s%2Fm%2F07k6cg0?entry=ttu&g_ep=EgoyMDI0MTEwNS4wIKXMDSoASAFQAw%3D%3D"
              className="text-[#33358c] bg-white py-2 px-6 rounded-full text-lg font-semibold transition duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg"
            >
              Directions
            </a>
          </div>
        </div>
      </div>

      {/* Location Details Section */}
      <div className="bg-[#f8f9fa] p-6 lg:p-10">
        <h1 className="text-3xl font-bold text-[#33358c] mb-6">How to Reach IILM University, Greater Noida</h1>

        {/* Location Address */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-[#33358c] mb-4">Location:</h2>
          <p className="text-lg">
          Plot No. 16-18,Knowledge Park II, Greater Noida, Uttar Pradesh 201310, India
          </p>
        </div>

        {/* Directions */}
        <div className="space-y-8">
          {/* Bus Directions */}
          <div>
            <h2 className="text-xl font-semibold text-[#33358c] mb-2">By Bus:</h2>
            <p className="text-lg">
              Take a bus to <b>Pari Chowk, Greater Noida</b>.<br></br> From Pari Chowk, you can
              take a local autorickshaw or shared cab to reach<br></br> IILM University, which is about 3 km away.
            </p>
          </div>

          {/* Train Directions */}
          <div>
            <h2 className="text-xl font-semibold text-[#33358c] mb-2">By Train:</h2>
            <p className="text-lg">
              The nearest railway station is <b>New Delhi Railway Station</b>,<br></br> located approximately 45 km away. 
              From there, you can take a metro to the <br></br><b>Botanical Garden Metro Station (Aqua Line)</b> and 
              then a direct metro to <br></br><b>Knowledge Park II Metro Station</b>, which is a 5-minute walk to the university.
            </p>
          </div>

          {/* Airport Directions */}
          <div>
            <h2 className="text-xl font-semibold text-[#33358c] mb-2">By Airport:</h2>
            <p className="text-lg">
              The nearest airport is <b>Indira Gandhi International Airport, New Delhi</b>. 
              <br></br>From the airport, you can book a cab or take the airport metro to reach 
              <br></br><b>Knowledge Park II Metro Station</b>, located near IILM University.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
